// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fbded73d","455":"63eac39a","977":"a74e4423"}[chunkId] + ".chunk.js";
};